import { cloneDeep } from 'lodash';

import * as actionTypes from '../actions/actionTypes';

const initialState = {
    isLoginProcessing: false,
    user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null,
    message: null,
    isIlliquid: false,
    hasNotConfirmedContact: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).hasNotConfirmedContact : false,
    errorStatus: null,
};

const loginProcessing = (state) => {
    return {
        ...state,
        isLoginProcessing: true
    }
}

const setIsIlliquid = (state, action) => {
    return {
        ...state,
        isIlliquid: action.isIlliquid,
        isLoginProcessing: false,
        message: null,
        errorStatus: null,
    }
}

const loginSuccess = (state, action) => {
    localStorage.setItem("user", JSON.stringify({ ...action.user }));
    return {
        ...state,
        isLoginProcessing: false,
        user: { ...action.user },
        message: action.message,
        isIlliquid: false,
    }
}

const loginFailed = (state, action) => {
    return {
        ...state,
        message: action.message,
        errorStatus: action.errorStatus,
        isLoginProcessing: false
    }
}

const logout = (state) => {
    return {
        ...state,
        isLoginProcessing: false,
        user: null,
        isIlliquid: false,
        message: null,
        errorStatus: null,
        hasNotConfirmedContact: false,
    }
}

const updatePhoto = (state, action) => {
    let tmp = { ...state.user }
    tmp.photoUrl = action.src.length !== 0 ? action.src : null
    localStorage.setItem("user", JSON.stringify({ ...tmp }));
    return {
        ...state,
        user: { ...tmp }
    }
}

const checkIfContactsAreVerified = (state, action) => {
    const tmp = cloneDeep(state.user)
    if (tmp) {
        tmp.hasNotConfirmedContact = action.hasNotConfirmedContact
        localStorage.setItem("user", JSON.stringify({ ...tmp }))
    }
    return {
        ...state,
        hasNotConfirmedContact: action.hasNotConfirmedContact
    }
}

const clearAuthState = (state) => {
    return {
        ...state,
        message: null,
        errorStatus: null
    }
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LOGIN_PROCESSING: return loginProcessing(state);
        case actionTypes.LOGIN_SUCCESS: return loginSuccess(state, action);
        case actionTypes.LOGIN_FAILED: return loginFailed(state, action);
        case actionTypes.IS_ILLIQUID: return setIsIlliquid(state, action);
        case actionTypes.LOGOUT: return logout(state);
        case actionTypes.UPDATE_PHOTO: return updatePhoto(state, action);
        case actionTypes.ARE_CONTACTS_VERIFIED: return checkIfContactsAreVerified(state, action);
        case actionTypes.CLEAR_AUTH_ERROR: return clearAuthState(state);
        default: return state;
    }
};
export default reducer;